import {
  ADVISOR_CLIENT_PLANS_RECEIVED,
  ADVISOR_CLIENT_PLANS_UNLOADED
} from './types'

export default function plans(state = [], action = {}){
  switch (action.type) {     
    case ADVISOR_CLIENT_PLANS_RECEIVED:
      return action.data
    case ADVISOR_CLIENT_PLANS_UNLOADED:
        return []
    default:
      return state;
  }
}